// extracted by mini-css-extract-plugin
export default {"label":"styles__label___oepZ5","required":"styles__required___72bF7","description":"styles__description___qYfA5","adminIcon":"styles__adminIcon___ttrkb"};